"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/Envelope.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Envelope = function Envelope(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 192.11 136.36"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Envelope Icon"), _react2.default.createElement("path", {
    className: "envelope",
    d: "M176.63 0H15.49A15.49 15.49 0 0 0 0 15.47V120.9a15.49 15.49 0 0 0 15.49 15.46h161.14a15.49 15.49 0 0 0 15.49-15.46V15.47A15.49 15.49 0 0 0 176.63 0zm0 6.19a9.24 9.24 0 0 1 4.45 1.14L103.36 75a11.63 11.63 0 0 1-14.61 0L11 7.33a9.24 9.24 0 0 1 4.46-1.14h161.17zm9.29 114.71a9.3 9.3 0 0 1-9.29 9.28H15.49a9.3 9.3 0 0 1-9.29-9.28V15.47a9.21 9.21 0 0 1 .7-3.52l77.78 67.68a17.83 17.83 0 0 0 22.75 0l77.79-67.68a9.21 9.21 0 0 1 .7 3.53V120.9z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }));
};
exports.default = Envelope;